<div class="alert alert-info alert-primary typography">
  <div class="alert-content grid grid-center">
    <div class="alert-message">
      {{ message$ | async }}
    </div>
  </div>
</div>

<div class="typography grid pt-8" *ngIf="phones$ | async as phones">
  <ng-container *ngTemplateOutlet="phoneTmp; context: { phone: phones.company }"></ng-container>
  <ng-container *ngTemplateOutlet="phoneTmp; context: { phone: phones.federal }"></ng-container>
</div>

<ng-template #phoneTmp let-phone="phone">
  <div class="grid-item grid-6 centered">
    <a [href]="'tel:' + phone">{{ phone }}</a>
  </div>
</ng-template>
